<section class="validate-container">
  <opath-core-nav-header #header [title]="translation.title" [hideFilterPanel]="true"> </opath-core-nav-header>
  <div fxLayout="column" fxLayoutAlign="center center" class="validate-result" *ngIf="!validationResult">
    <i class="icon dx-icon-info"></i>
    <h3>{{ translation?.expressionChanged }}</h3>
  </div>

  <ng-container *ngIf="validationResult">
    <div
      fxLayout="column"
      fxLayoutAlign="center center"
      *ngIf="
        (validationResult.RefObjectTypeName && validationType === ValidationType.Query) ||
          (validationResult.ValueCount && validationType === ValidationType.Column);
        else invalid
      "
    >
      <i class="icon dx-icon-todo"></i>
      <h3>{{ translation?.valid }}</h3>
    </div>

    <ng-template #invalid>
      <div fxLayout="column" fxLayoutAlign="center center" class="invalid-result">
        <i class="icon dx-icon-close big"></i>
        <h3>{{ translation?.invalid }}</h3>
        <ng-container *ngIf="validationResult.Errors.length; else validationError">
          <div fxLayout="row" fxLayoutAlign="start center" *ngFor="let error of validationResult.Errors">
            <i class="icon dx-icon-close" fxFlex="10%"></i>
            <p>{{ error.Message }}</p>
          </div>
        </ng-container>
        <ng-template #validationError>
          <div fxLayout="row" fxLayoutAlign="start center">
            <i class="icon dx-icon-close" fxFlex="10%"></i>
            <div>
              <p>{{ translation?.typeError }}</p>
              <p>{{ translation?.isRefError }}</p>
            </div>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </ng-container>

  <div fxLayout="column" fxLayoutAlign="center center">
    <abc-button width="80px" height="35px" (click)="executeValidation()" class="validate-button">
      <div *dxTemplate="let data of 'content'">
        <ng-container *ngIf="loadingValidation; else showButtonText">
          <abc-load-indicator width="22px" height="22px" [visible]="loadingValidation"> </abc-load-indicator>
        </ng-container>
        <ng-template #showButtonText>{{ translation?.button }}</ng-template>
      </div>
    </abc-button>
  </div>
</section>
